export enum UserFeatureFlags {
  ShowProtocolData = 'visualizza_dati_protocollo',
  ShowPhaseFilter = 'visualizza_filtro_fase',
  ShowDirectorOpinions = 'visualizza_pareri_dei_direttori'
}
